import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {CoinsProductInterface, CoinsSellerInterface} from "@/modules/action-points/interfaces";
// import { Purchases } from '@awesome-cordova-plugins/purchases';

@injectable()
export default class RevenueCatCoinsSeller implements CoinsSellerInterface {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  async buy(product: CoinsProductInterface) {
    // Purchases.setDebugLogsEnabled(true);
    // Purchases.configureWith({
    //   apiKey: 'sk_gYZAPqjIYsxNoNbQhtNKZVBlbZesD',
    // });
    //
    // console.log(await Purchases.getOfferings());

    console.log(`Web: ${product.coins} coins bought via ${product.name}.`);

    return true;
  }

  getProducts(): Promise<CoinsProductInterface[]> {
    return Promise.resolve([]);
  }
}
